import { __decorate } from "tslib";
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { AuthService } from '../../services/auth.service';
import { LoginComponent } from './../login';
import { ComponentService } from './../../services/component.service';
import { Router } from '@angular/router';
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { EmailGoogleRegistrationComponent } from "../register/email-google-registration/email-google-registration.component";
/**
 * Header Component
 */
let HeaderComponent = class HeaderComponent {
    constructor(httpClient, compService, auth, router, webSettingsService, sanitizer, themeService, deviceService, changeDetector, googleAnalyticsService) {
        this.httpClient = httpClient;
        this.compService = compService;
        this.auth = auth;
        this.router = router;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.deviceService = deviceService;
        this.changeDetector = changeDetector;
        this.googleAnalyticsService = googleAnalyticsService;
        this.loggedIn = false;
        this.userData = {};
        this.isResponsive = false;
        this.color = '';
        this.logoImg = '';
        this.accentColor = '';
        this.mainColor = '';
        this.pulseColor = '';
        this.pulse2Color = '';
        this.showPersonalVerification = false;
        this.isDesktop = true;
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.goToHpLink = '';
        this.goToShopLink = '';
        this.showHomepageLink = false;
        this.toggleList = false;
        this.isDesktopDevice = true;
        this.isCompanyUser = true;
        this.region = '';
        this.userDocumentVerificationUpload = false;
        this.userDocumentsSubmitted = false;
        this.companyDocumentsSubmitted = false;
        if (window.innerWidth >= 992) {
            this.isDesktop = true;
        }
        else {
            this.isDesktop = false;
        }
        this.webSettingsService.getSettings().subscribe((data) => {
            this.showPersonalVerification = this.webSettingsService.applySettings("VERIFICATIONS.PERSONAL_VERIFICATION");
            this.showHomepageLink = this.webSettingsService.applySettings("MENU.HOMEPAGE_LINK.VISIBLE");
            this.goToHpLink = this.webSettingsService.getCustomValue("MENU.HOMEPAGE_LINK.VALUE");
            this.goToShopLink = this.webSettingsService.getCustomValue("MENU.SHOP_PAGE_LINK.VALUE");
        });
        this.auth.getStatus().subscribe((result) => {
            this.loggedIn = result;
            if (this.loggedIn === true) {
                this.userData = JSON.parse(localStorage.getItem('user'));
                if (this.userData) {
                    this.status = this.userData.personally_validated;
                    this.validated = this.userData.validated;
                    this.isCompanyUser = this.userData.is_company_user;
                    this.region = this.webSettingsService.getWebSetting('APP_REGION');
                    this.userDocumentVerificationUpload = this.userData.user_document_verification_upload == '1';
                    this.userDocumentsSubmitted = this.userData.user_documents_submitted == '1';
                    if (this.isCompanyUser) {
                        this.companyDocumentsSubmitted = this.userData.company.documents_submitted == '1';
                    }
                }
            }
        });
        this.router.events.subscribe((event) => {
            this.isResponsive = false;
        });
    }
    ngOnInit() {
        this.themeService.getTheme().subscribe((data) => {
            this.color = this.themeService.getStyleAttribute('text_color');
            this.logoImg = this.themeService.getStyleAttribute('logo_image');
            if (this.logoImg === '' || this.logoImg === ' ' || this.logoImg === null) {
                this.logoImg = 'assets/img/logo-not-found.png';
            }
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.pulseColor = this.themeService.getStyleAttribute('pulse_color');
            this.pulse2Color = this.themeService.getStyleAttribute('pulse2_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    onResize(event) {
        if (event.target.innerWidth >= 992) {
            this.isDesktop = true;
        }
        else {
            this.isDesktop = false;
        }
    }
    openLogin() {
        let array = [];
        array.push({
            'event': 'loginRegisterCTAclick',
            button: 'login',
            position: 'header'
        });
        this.googleAnalyticsService.pushGAEvents(array);
        document.body.className += ' ' + 'modal-open';
        this.compService.openModal(LoginComponent);
    }
    openRegister() {
        let array = [];
        array.push({
            'event': 'loginRegisterCTAclick',
            button: 'register',
            position: 'header'
        });
        this.googleAnalyticsService.pushGAEvents(array);
        document.body.className += ' ' + 'modal-open';
        this.compService.openModal(EmailGoogleRegistrationComponent);
    }
    logOut() {
        sessionStorage.removeItem('chosenType');
        sessionStorage.removeItem('chosenCurrency');
        this.auth.logOut(true);
    }
    openResponsive() {
        this.isResponsive = !this.isResponsive;
        this.isDesktop = false;
    }
    goToHp() {
        const buttonName = this.webSettingsService.getKeyValue('NAVIGATION.HOMEPAGE');
        let array = [];
        array.push({
            'event': 'navigationMenuCTAclick',
            button: buttonName
        });
        this.googleAnalyticsService.pushGAEvents(array);
        window.open(this.goToHpLink, '_self');
    }
    googleAnalyticsClick(category) {
        let buttonName = this.webSettingsService.getKeyValue(category);
        let array = [];
        array.push({
            'event': 'navigationMenuCTAclick',
            button: buttonName
        });
        this.googleAnalyticsService.pushGAEvents(array);
    }
    googleAnalyticsClickLogo() {
        let array = [];
        array.push({
            'event': 'navigationMenuCTAclick',
            button: 'Logo'
        });
        this.googleAnalyticsService.pushGAEvents(array);
    }
    onDocumentClick(event) {
        const targetElement = event.target;
        if (targetElement.className !== 'clickClass' &&
            targetElement.className !== 'clickClassLi') {
            this.toggleDropdown();
        }
    }
    toggleDropdown() {
        this.toggleList = !this.toggleList;
    }
    onResizeDevice(event) {
        this.deviceType();
        this.changeDetector.detectChanges();
    }
    deviceType() {
        this.isDesktopDevice = this.deviceService.isDesktop();
    }
    goToShop() {
        const buttonName = this.webSettingsService.getKeyValue('NAVIGATION.SHOP');
        let array = [];
        array.push({
            'event': 'navigationMenuCTAclick',
            button: buttonName
        });
        this.googleAnalyticsService.pushGAEvents(array);
        window.open(this.goToShopLink, '_self');
    }
};
HeaderComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ComponentService },
    { type: AuthService },
    { type: Router },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: DeviceDetectorService },
    { type: ChangeDetectorRef },
    { type: GoogleAnalyticsService }
];
__decorate([
    HostListener('document:click', ['$event'])
], HeaderComponent.prototype, "onDocumentClick", null);
__decorate([
    HostListener('window:resize', ['$event'])
], HeaderComponent.prototype, "onResizeDevice", null);
HeaderComponent = __decorate([
    Component({
        selector: 'ecd-header',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./header.component.html")).default
    })
], HeaderComponent);
export { HeaderComponent };
